import React, {Suspense} from 'react';

import {View, XStack, YStack} from '@medad-sep/core';
import {AppTopBar} from '@shared/components/AppTopBar';
import {PageFallback} from '@shared/components/PageFallback';
import {useCurrentUserConfig} from '@shared/hooks/ui/useCurrentUserConfig';
import {SectionSidebarProvider} from '@shared/context/SectionSidebarContext';

import {AppSideBar} from '../AppSideBar';
import {useMedia} from "tamagui";

interface Props {
  children: any;
}

export function AppSection({children}: Props) {
  const {menuItems} = useCurrentUserConfig();
  const media = useMedia();
  const isMobile = !!(media?.xs || media?.sm);
  const content = <Suspense fallback={<PageFallback />}>{children}</Suspense>;

  return (
    <SectionSidebarProvider>
      <View height="100vh">
        <AppTopBar />
        {isMobile ? (
          <YStack flex={1}>
            <YStack flex={1}>{content}</YStack>
            <AppSideBar menuItems={menuItems} placement="bottom" />
          </YStack>
        ) : (
          <XStack flex={1}>
            <AppSideBar menuItems={menuItems} />
            <YStack flex={1}>{content}</YStack>
          </XStack>
        )}
      </View>
    </SectionSidebarProvider>
  );
}
